import { useEffect } from 'react';

const ImagePreloader = ({images}) => {
    useEffect(() => {
        images.forEach(image => {
            const img = new Image();
            img.src = image;
        });
    }, []);

    return null;
};

export default ImagePreloader;